export default __webpack_public_path__ + "static/PSSE-9b37e503e0b19851995f372eee0aafba.png";